import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import { Row, Col, HelpBlock, Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import EmailInstructionsDialog from './EmailInstructionsDialog';
import {
	checkEmail, getAuthenticationRecords,
	AUTHENTICATION_RECORDS_REQUEST, AUTHENTICATION_RECORDS_SUCCESS, AUTHENTICATION_RECORDS_FAILURE
} from './actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faQuestion } from '@fortawesome/free-solid-svg-icons';

class EmailWithCheck extends Component {
	constructor(props) {
		super(props);
		this.showEmailInstructionsDialog = this.showEmailInstructionsDialog.bind(this);
		this.hideEmailInstructionsDialog = this.hideEmailInstructionsDialog.bind(this);
		this.toggleEmailAddressHelp = this.toggleEmailAddressHelp.bind(this);
		this.handleEmailCheck = this.handleEmailCheck.bind(this);

		this.state = {
			showEmailSetupInstructions: false,
			showEmailInstructionsDialog: false,
			showSuccessCheckEmail: false
		};
	}

	componentDidMount() {
		this.props.getAuthenticationRecords();
	}

	showEmailInstructionsDialog() {
		this.setState({
			showEmailInstructionsDialog: true
		});
	}

	hideEmailInstructionsDialog() {
		this.setState({
			showEmailInstructionsDialog: false		
		});
	}

	toggleEmailAddressHelp() {
		this.setState({ showEmailSetupInstructions: !this.state.showEmailSetupInstructions })
	}

	handleEmailCheck(email) {
		this.setState({ showSuccessCheckEmail: false })
		this.props.checkEmail({ fromEmailAddress: email, fieldName: this.props.name },
			() => this.setState({ showSuccessCheckEmail: true }), this.props.formName);
	}

	render() {
		const { email, authenticationRecords, t, labelCol = 2, valueCol = 10, ...rest } = this.props;

		return <span>
			<Field
				labelCol={labelCol}
				valueCol={valueCol}
				action={<React.Fragment><Button bsStyle='success' onClick={() => this.handleEmailCheck(email)}><FontAwesomeIcon icon={faCheck} /> {t('EmailInfrastructureValidator_Check')}</Button>
					<Button bsStyle='warning' onClick={this.toggleEmailAddressHelp}><FontAwesomeIcon icon={faQuestion} /></Button></React.Fragment>}
				help={this.state.showSuccessCheckEmail && t('EmailInfrastructureValidator_Valid')}
				success={this.state.showSuccessCheckEmail}
				{...rest}
			/>
			{this.state.showEmailSetupInstructions && <Row style={{ marginTop: -5 }}>
				<Col smOffset={labelCol} sm={valueCol}>
					<p className='emailCheckerHelp'>
						<HelpBlock>{t('EmailInfrastructureValidator_Help')}</HelpBlock>
						<a onClick={this.showEmailInstructionsDialog} style={{ cursor: 'pointer' }}>{t('EmailInfrastructureSetup_View')}</a>
					</p>
				</Col>
			</Row>}
			<EmailInstructionsDialog
				records={authenticationRecords}
				show={this.state.showEmailInstructionsDialog}
				onCancel={this.hideEmailInstructionsDialog}
				block={[AUTHENTICATION_RECORDS_REQUEST]}
				unblock={[AUTHENTICATION_RECORDS_SUCCESS, AUTHENTICATION_RECORDS_FAILURE]}
			/>
		</span>
	};
}

const mapStateToProps = (state) => {
	const {
		entities: { authenticationRecords }
	} = state;

	return {
		authenticationRecords: Object.values(authenticationRecords)[0]
	};
};

const mapDispatchToProps = {
	getAuthenticationRecords,
	checkEmail
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(EmailWithCheck));